import React from 'react'
import { useTranslation } from 'react-i18next'

import { FieldProps } from '../../../../../../../@types/types'
import { CostsScreenValidationResult } from '../../../../../../../@types/validation-types'
import TextArea from '../../../../../../common/inputs/textArea/TextArea'

const CourtageNote: React.FC<FieldProps<CostsScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
}) => {
  const { t } = useTranslation()

  return (
    <div className='grid-item one-whole'>
      <div className='inline-block margin-top-m one-whole'>
        <div className='inline-block two-twelfth align-top padding-top-m'>
          <span className='lap-margin-left-m desk-margin-left-m margin-left-xl path-symbol-before' />
        </div>
        <div className='inline-block ten-twelfth'>
          <TextArea
            id='courtage-note'
            allowResize={true}
            errors={validationMessages?.courtageNote ?? []}
            name='courtageNote'
            rows={8}
            value={insertionData.courtageNote}
            placeholder={t('wizard.screen.costs.courtageNote', 'Courtage note')}
            showMaxLengthLabel={true}
            maxLength={500}
            onChange={(property, value) => onChange({ screen: screenName, property }, value)}
          />
        </div>
      </div>
    </div>
  )
}

export default CourtageNote
